import { render, staticRenderFns } from "./FacialOrderInfo.vue?vue&type=template&id=43427fc6&scoped=true"
import script from "./FacialOrderInfo.vue?vue&type=script&lang=js"
export * from "./FacialOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./FacialOrderInfo.vue?vue&type=style&index=0&id=43427fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43427fc6",
  null
  
)

export default component.exports